import Button from "@/components/Button/index";
import Modal from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { InfoOutlined } from "@dextech-ai/dex-design-system/icons";
import { PropTypes } from "prop-types";

const SharePrincipalInfoModal = ({ visible, hide }) => {
	return (
		<Modal visible={visible} close={hide} dismissClickOutsideModal={false}>
			<ModalHeader icon={<InfoOutlined data-ds-color="primary-dark" />}>
				<ModalTitle>Share principal list</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div className="eap-modal__content center">
					By enabling this function, you will be displaying
					your list of Principal(s) to all users. Users will
					be able to view your Principal(s) within specific
					use cases and can initiate consent with you to
					provide or consume data on behalf of these
					Principal(s).
				</div>
			</ModalBody>
			<ModalFooter>
				<ModalFooterRight>
					<Button
						full
						maxWidth="100"
						submit={() => hide()}
						text="Okay, got it!"
					/>
				</ModalFooterRight>
			</ModalFooter>
		</Modal>
	);
};

SharePrincipalInfoModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	hide: PropTypes.func.isRequired,
};

export default SharePrincipalInfoModal;
